import type { Transition, Variants } from "framer-motion";

/** Durées, courbes et distances communes à toutes les animations de l'application. */
export const motionTokens = {
  duration: {
    instant: 0.08,
    fast: 0.18,
    normal: 0.35,
    slow: 0.6,
    crawl: 1.0,
  },
  easing: {
    smooth: [0.22, 1, 0.36, 1],
    sharp: [0.4, 0, 0.2, 1],
  },
  distance: {
    xs: 4,
    sm: 8,
    md: 16,
  },
  stagger: 0.06,
} as const;

/** Ressorts nommés : on n'écrit jamais stiffness/damping directement dans un composant. */
export const springs = {
  snappy: { type: "spring", stiffness: 300, damping: 30 },
  gentle: { type: "spring", stiffness: 120, damping: 18 },
  instant: { type: "spring", stiffness: 600, damping: 35 },
} satisfies Record<string, Transition>;

/** Conteneur qui fait apparaître ses enfants les uns après les autres. */
export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: motionTokens.stagger } },
};

/** Élément qui monte légèrement en apparaissant (enfant d'un staggerContainer). */
export const riseItem: Variants = {
  hidden: { opacity: 0, y: motionTokens.distance.md },
  visible: { opacity: 1, y: 0, transition: { duration: motionTokens.duration.normal, ease: motionTokens.easing.smooth } },
};
